import React, { useState } from 'react'
import { SketchPicker } from 'react-color'

export default (props) => {
    const { colorObj, newColor, setNewColor } = props
    const variable = Object.keys(colorObj)[0]
    const [displayColorPicker, setdisplayColorPicker] = useState(false)
    const [color, setColor] = useState(colorObj[variable])
    const handleClick = () => {
        setdisplayColorPicker(!displayColorPicker)
    }
    const handleClose = () => {
        setdisplayColorPicker(false)
    }
    return (
        <div>
            <div style={{
                padding: '5px',
                background: '#fff',
                borderRadius: '1px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                display: 'inline-block',
                cursor: 'pointer',
            }} onClick={handleClick}>
                <div style={{
                    width: '62px',
                    height: '14px',
                    borderRadius: '2px',
                    background: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
                }} />
            </div>
            { displayColorPicker ? <div style={{
                position: 'absolute',
                zIndex: '2',
            }}>
                <div style={{
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                }} onClick={handleClose} />
                <SketchPicker color={color}
                    onChange={(color) => {
                        setColor(color.rgb)
                    }}
                    onChangeComplete={
                        (color, event) => {
                            let newColorVariable = {}
                            newColorVariable[variable] = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`
                            setNewColor({ ...newColor, ...newColorVariable })
                        }
                    }
                />
            </div> : null}

        </div>
    )
}